<template>
  <v-container class="content-font-size pt-0" fluid>
    <v-row
      class="background-color-white rounded-lg mb-3 mb-sm-6 mr-sm-0 px-3 px-sm-6"
    >
      <v-col>
        <v-row>
          <v-col class="header-font-size mb-0 mb-sm-5"
            >Account Information</v-col
          >
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" class="font-weight py-0 py-sm-3">Email</v-col>
          <v-col cols="10" sm="7">{{ wait(user, "email") }}</v-col>
          <v-col cols="2">
            <a
              class="font-weight-semibold text-decoration-underline"
              @click.stop="dialog.email = true"
              >Change</a
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" class="font-weight py-0 py-sm-3"
            >Password</v-col
          >
          <v-col cols="10" sm="7"
            >&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</v-col
          >
          <v-col cols="2">
            <a
              class="font-weight-semibold text-decoration-underline"
              @click.stop="dialog.password = true"
              >Change</a
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="background-color-white rounded-lg mb-0 mb-sm-6 mr-sm-0 px-3 px-sm-6"
    >
      <v-col>
        <v-row>
          <v-col class="header-font-size mb-0 mb-sm-5"
            >Personal Information</v-col
          >
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" class="font-weight py-0 py-sm-3"
            >Full Name</v-col
          >
          <v-col cols="9">{{ wait(user, "name") }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" class="font-weight py-0 py-sm-3">Phone</v-col>
          <v-col cols="9">{{ formatPhoneNumber(wait(user, "phone")) }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" class="font-weight py-0 py-sm-3"
            >Birthday</v-col
          >
          <v-col cols="9">{{ renderBirthDate() }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <a
              class="font-weight-semibold text-decoration-underline"
              @click.stop="dialog.personal = true"
              >Change</a
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <EditEmailDialog
      :close="() => close('email')"
      :dialog="dialog.email"
      :save="save"
    />
    <EditPasswordDialog
      :close="() => close('password')"
      :dialog="dialog.password"
      :save="save"
    />
    <EditPersonalInformationDialog
      :close="() => close('personal')"
      :dialog="dialog.personal"
      :save="save"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { formatPhoneNumber, wait } from "@/util.js";
import EditEmailDialog from "@/components/Account/MyProfile/EditEmailDialog.vue";
import EditPasswordDialog from "@/components/Account/MyProfile/EditPasswordDialog.vue";
import EditPersonalInformationDialog from "@/components/Account/MyProfile/EditPersonalInformationDialog.vue";

export default {
  name: "MyProfile",
  components: {
    EditEmailDialog,
    EditPasswordDialog,
    EditPersonalInformationDialog,
  },
  computed: {
    ...mapState({
      user: (state) => state.user.info,
    }),
  },
  data() {
    return {
      dialog: {
        email: false,
        password: false,
        personal: false,
      },
    };
  },
  methods: {
    close(name) {
      this.dialog[name] = !this.dialog[name];
    },
    formatPhoneNumber,
    renderBirthDate() {
      const defaultText = "Add your date of birth";
      return this.user
        ? this.user.birthday
          ? this.user.birthday
          : defaultText
        : null;
    },
    save(info) {
      this.$store.dispatch("user/update", info);
    },
    wait,
  },
};
</script>
<style scoped>
.content-font-size {
  font-size: var(--font-size-sm);
}
@media (min-width: 668px) {
  .content-font-size {
    font-size: var(--font-size-md);
  }
}

.font-weight {
  font-weight: var(--font-weight-semibold);
}
@media (min-width: 668px) {
  .font-weight {
    font-weight: var(--font-weight-regular);
  }
}

.header-font-size {
  font-size: var(--font-size-md);
}
@media (min-width: 668px) {
  .header-font-size {
    font-size: var(--font-size-lg);
  }
}
</style>
